export default __webpack_public_path__ + "static/media/image not found.1907fa0d.png";